"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBase64Content = exports.getTextContent = exports.getOrigin = exports.getUrl = exports.createErr = exports.ErrorWithCode = exports.getAbsoluteUrl = exports.createId = void 0;
var uniqId_1 = __importDefault(require("licia/uniqId"));
var random_1 = __importDefault(require("licia/random"));
var startWith_1 = __importDefault(require("licia/startWith"));
var Url_1 = __importDefault(require("licia/Url"));
var convertBin_1 = __importDefault(require("licia/convertBin"));
var axios_1 = __importDefault(require("axios"));
var prefix = random_1.default(1000, 9999) + '.';
function createId() {
    return uniqId_1.default(prefix);
}
exports.createId = createId;
function getAbsoluteUrl(url) {
    var a = document.createElement('a');
    a.href = url;
    return a.href;
}
exports.getAbsoluteUrl = getAbsoluteUrl;
var ErrorWithCode = (function (_super) {
    __extends(ErrorWithCode, _super);
    function ErrorWithCode(code, message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.code = code;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return ErrorWithCode;
}(Error));
exports.ErrorWithCode = ErrorWithCode;
function createErr(code, message) {
    return new ErrorWithCode(code, message);
}
exports.createErr = createErr;
function getUrl() {
    var href = location.href;
    if (startWith_1.default(href, 'about:')) {
        return parent.location.href;
    }
    return href;
}
exports.getUrl = getUrl;
function getOrigin() {
    var origin = location.origin;
    if (origin === 'null') {
        return parent.location.origin;
    }
    return origin;
}
exports.getOrigin = getOrigin;
function getTextContent(url, proxy) {
    if (proxy === void 0) { proxy = ''; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getContent(url, 'text', proxy)];
                case 1: return [2, _a.sent()];
            }
        });
    });
}
exports.getTextContent = getTextContent;
function getBase64Content(url, proxy) {
    if (proxy === void 0) { proxy = ''; }
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = convertBin_1.default;
                    return [4, getContent(url, 'arraybuffer', proxy)];
                case 1: return [2, _a.apply(void 0, [_b.sent(), 'base64'])];
            }
        });
    });
}
exports.getBase64Content = getBase64Content;
function getContent(url, responseType, proxy) {
    if (proxy === void 0) { proxy = ''; }
    return __awaiter(this, void 0, void 0, function () {
        var urlObj, result, e_1, result, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 8]);
                    urlObj = new Url_1.default(url);
                    urlObj.setQuery('__chobitsu-hide__', 'true');
                    return [4, axios_1.default.get(urlObj.toString(), {
                            responseType: responseType,
                        })];
                case 1:
                    result = _a.sent();
                    return [2, result.data];
                case 2:
                    e_1 = _a.sent();
                    if (!proxy) return [3, 7];
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 6, , 7]);
                    return [4, axios_1.default.get(proxyUrl(proxy, url), {
                            responseType: responseType,
                        })];
                case 4:
                    result = _a.sent();
                    return [4, result.data];
                case 5: return [2, _a.sent()];
                case 6:
                    e_2 = _a.sent();
                    return [3, 7];
                case 7: return [3, 8];
                case 8: return [2, responseType === 'arraybuffer' ? new ArrayBuffer(0) : ''];
            }
        });
    });
}
function proxyUrl(proxy, url) {
    var urlObj = new Url_1.default(proxy);
    urlObj.setQuery('url', url);
    urlObj.setQuery('__chobitsu-hide__', 'true');
    return urlObj.toString();
}
